import { watch } from "vue";
import { useSessionStorage, useLocalStorage } from "@vueuse/core";
import { isEmpty } from "lodash";

export function usePreferredSessionStorage<T>(key: string, defaultValue: T) {
  const sessionValue = useSessionStorage<T>(key, defaultValue);
  const localValue = useLocalStorage<T>(key, defaultValue);

  // Initialize session storage from local storage if session storage is empty
  if (isEmpty(sessionValue.value) && !isEmpty(localValue.value)) {
    sessionValue.value = localValue.value;
  }

  // Watch for changes in session storage and update local storage
  watch(sessionValue, (newValue) => {
    localValue.value = newValue;
  });

  return sessionValue;
}
